import { component as defineComponent } from 'flightjs';
import dot from 'dot/doT';
import $ from 'jquery';

function HtmlUpdater() {
    this.defaultAttrs({
        eventName: null,
        templateSelector: null,
    });

    this.after('initialize', function () {
        this.on(document, this.attr.eventName, this.updateHtml);
    });

    this.updateHtml = function () {
        const html = $(this.attr.templateSelector).html();
        const template = dot.template(html);
        this.$node.html(template);
    };
}

export default defineComponent(HtmlUpdater);



// WEBPACK FOOTER //
// ./src/js/component_ui/html-updater.js